import { platformVisitAction } from "../Redux/Action/AuthAction";

const VISIT_LAST_KEY = "platform_visit_last_login_key";
const VISIT_INFLIGHT_KEY = "platform_visit_inflight_key";

export const recordPlatformVisit = async (dispatch, loginKey, userData) => {
  if (!loginKey) return;

  let lastKey = null;
  let inflightKey = null;

  try {
    lastKey = sessionStorage.getItem(VISIT_LAST_KEY);
    inflightKey = sessionStorage.getItem(VISIT_INFLIGHT_KEY);
  } catch {
    // sessionStorage may be unavailable (privacy mode / blocked)
  }

  if (lastKey === loginKey || inflightKey === loginKey) {
    return;
  }

  try {
    sessionStorage.setItem(VISIT_INFLIGHT_KEY, loginKey);
  } catch {
    // If we can't persist, proceed without the guard
  }

  try {
    const res = await dispatch(platformVisitAction());
    if (res?.meta?.requestStatus === "fulfilled") {
      try {
        sessionStorage.setItem(VISIT_LAST_KEY, loginKey);
      } catch {
        // ignore
      }
    }
  } finally {
    try {
      sessionStorage.removeItem(VISIT_INFLIGHT_KEY);
    } catch {
      // ignore
    }
  }
};

export const clearPlatformVisitMarkers = () => {
  try {
    sessionStorage.removeItem(VISIT_LAST_KEY);
    sessionStorage.removeItem(VISIT_INFLIGHT_KEY);
  } catch {
    // sessionStorage may be unavailable (privacy mode / blocked)
  }
};
